import type { ReplayPlugin } from "@slot/client-engine";
import type { GameFeature } from "@slot/game-shell";
import { ExpandingWildActionHandler, type VsBattleInput, type VsBattlePresentationTarget } from "./replay/ExpandingWildActionHandler";

/** The battle's reel effect: the VS-spine wild over a reel, played to its end. */
export interface VsBattleWilds {
  expandColumn(input: VsBattleInput): Promise<void>;
}

export interface VsBattleFeatureDeps {
  /** The reel effect; null → the battle's sound and the bear's reaction only. */
  wilds: VsBattleWilds | null;
  /** The bear's reaction (once per spin, `CharacterView`); null without the bear. */
  reactCharacter: (() => void) | null;
  playSound: (soundId: string) => void;
}

/** The battle's stinger: played by id, so the speed modes' policy never skips it. */
const VS_BATTLE_SOUND_ID = "vs_battle";

/**
 * The VS battle: on each `expanding_wild` the stinger plays, the bear reacts, and the reel's battle plays to its end
 * (the engine awaits it, so several battles in one spin play one after another, left to right).
 */
export const vsBattleFeature: GameFeature<VsBattleFeatureDeps, VsBattlePresentationTarget, VsBattlePresentationTarget> = {
  createPresenter(deps) {
    return {
      presentBattle: async (input) => {
        deps.playSound(VS_BATTLE_SOUND_ID);
        deps.reactCharacter?.();
        await deps.wilds?.expandColumn(input);
      },
    };
  },

  createPlugin(target): ReplayPlugin {
    return { name: "vs-battle", actionHandlers: [new ExpandingWildActionHandler(target)] };
  },
};
